export enum DashboardScopes {
  CAN_VIEW = 'can_view_dashboard',
  CAN_UPDATE = 'can_update',
}
